/**
 * Short labels for the product snapshot "Average unit price by retailer" bar chart.
 * Keys must match retailer names from price history aggregates exactly.
 */
const RETAILER_SNAPSHOT_CHART_DISPLAY_NAMES = {
  "Real Canadian Superstore": "RCSS",
  "Walmart Canada": "Walmart",
  "Calgary Co-op": "Co-op",
  "Costco Wholesale": "Costco",
  "T&T Supermarket": "T&T",
  "Save-On-Foods": "Save-On",
  "Wholesale Club": "Wholesale",
  "Sobey's": "Sobeys",
};

/**
 * @param {string} retailerName
 * @returns {string}
 */
export function formatRetailerSnapshotChartLabel(retailerName) {
  const normalized = String(retailerName ?? "").trim();
  if (!normalized) return "";
  return RETAILER_SNAPSHOT_CHART_DISPLAY_NAMES[normalized] ?? normalized;
}
